import MainLayout from '@/layouts/main-layout';
import { useI18n } from '@/lib/i18n';
import ErrorImage from '@images/Error.png';
import { Link } from '@inertiajs/react';

export default function Help({ status, message }: { status: number; message: string }) {
  const { t } = useI18n();

  return (
    <MainLayout>
      <section className="mx-auto max-w-screen-lg">
        <div className="p-6 md:py-12 lg:py-20">
          <article className="prose lg:prose-lg mx-auto">
            <img className={'mx-auto h-auto w-2/3 rounded-3xl sm:mx-0 sm:h-48 sm:w-auto'} src={ErrorImage} alt={'Boostbuddy Error Image'} />

            <h1>{t('page.title')}.</h1>

            <p>{t('page.description')}</p>

            <p>
              <Link href={route('home')}>{t('page.Go to the homepage')}</Link> <span className={'mx-1'}>&middot;</span>{' '}
              <a href="mailto:info@boostbuddy.org">{t('page.Contact us')}</a>
            </p>

            <p>{t('page.thanks_text')}</p>

            <p className={'rounded-lg bg-gray-100 p-1 text-center italic'}>
              <small>
                {status}: {message}
              </small>
            </p>
          </article>
        </div>
      </section>
    </MainLayout>
  );
}
